"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.SignaturePadWrapper = exports.PreviewButton = exports.Placeholder = exports.Pad = exports.Header = exports.DialogContent = exports.Dialog = exports.ColorsContainer = exports.ColorButton = exports.CloseButton = exports.ClearButton = exports.CanvasContainer = exports.COLORS = exports.ButtonContainer = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SignaturePadWrapper = exports.SignaturePadWrapper = _styledComponents["default"].div.attrs({
  className: 'swiper-no-swiping'
}).withConfig({
  displayName: "styles__SignaturePadWrapper",
  componentId: "sc-48gcj7-0"
})([""]);
var dottedBorder = function dottedBorder(width, height, color, offset) {
  var OPEN_BRACKET = '%3c';
  var CLOSE_BRACKET = '%3e';
  var svg = "\n    <svg width='".concat(width, "px' height='").concat(height, "px' xmlns='http://www.w3.org/2000/svg'>\n      <rect\n        width='").concat(width - 10, "px'\n        height='").concat(height - 10, "px'\n        x='5px'\n        y='5px'\n        fill='none'\n        rx='6'\n        ry='6'\n        stroke='").concat(color, "'\n        stroke-width='2'\n        stroke-dasharray='15'\n        stroke-dashoffset='").concat(offset, "'\n        stroke-linecap='square'/>\n    </svg>\n");
  return "url(\"data:image/svg+xml,".concat(svg.replace(/</g, OPEN_BRACKET).replace(/>/g, CLOSE_BRACKET), "\")");
};
var PreviewButton = exports.PreviewButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__PreviewButton",
  componentId: "sc-48gcj7-1"
})(["min-height:60px;display:flex;flex:1;background-color:", ";border:none;background-image:", ";border-radius:6px;max-height:", "px;max-width:", "px;transition:all 0.3s ease-in-out;cursor:pointer;&:hover{background-image:", ";}"], _palette.commonPalette.darkerGray, function (p) {
  return dottedBorder(p.maxWidth, p.maxHeight, 'lightgray', 10);
}, function (p) {
  return p.maxHeight;
}, function (p) {
  return p.maxWidth;
}, function (p) {
  return dottedBorder(p.maxWidth, p.maxHeight, 'gray', 15);
});
var Placeholder = exports.Placeholder = _styledComponents["default"].div.withConfig({
  displayName: "styles__Placeholder",
  componentId: "sc-48gcj7-2"
})(["margin:auto;color:lightgray;font-style:italic;width:100%;height:100%;display:flex;align-items:center;justify-content:center;transition:all 0.3s ease-in-out;&:hover{color:gray;transform:scale(1.05);}"]);
var Dialog = exports.Dialog = _styledComponents["default"].dialog.withConfig({
  displayName: "styles__Dialog",
  componentId: "sc-48gcj7-3"
})(["padding:16px;border:0;z-index:10;position:fixed;border-radius:8px;overflow:hidden;&::backdrop{position:fixed;top:0px;right:0px;bottom:0px;left:0px;background:rgba(0,0,0,0.5);}"]);
var DialogContent = exports.DialogContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__DialogContent",
  componentId: "sc-48gcj7-4"
})(["display:flex;flex-direction:column;"]);
var ButtonContainer = exports.ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonContainer",
  componentId: "sc-48gcj7-5"
})(["display:flex;flex-direction:row;gap:1px;padding-top:16px;justify-content:space-between;"]);
var Button = exports.Button = _styledComponents["default"].button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-48gcj7-6"
})(["padding:4px 12px;border:none;background-color:", ";color:white;text-transform:uppercase;border-radius:3px;outline:none;", ""], _palette.commonPalette.sgGreen, function (p) {
  if (p.secondary) {
    return "\n            color: ".concat(_palette.commonPalette.txLightGrey, ";\n            background-color: ").concat(_palette.commonPalette.disabledText, ";\n        ");
  }
});
var Header = exports.Header = _styledComponents["default"].div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-48gcj7-7"
})(["display:flex;align-items:center;justify-content:space-between;padding-bottom:16px;"]);
var Title = exports.Title = _styledComponents["default"].h2.withConfig({
  displayName: "styles__Title",
  componentId: "sc-48gcj7-8"
})(["font-size:18px;font-weight:500;margin:0;"]);
var CloseButton = exports.CloseButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-48gcj7-9"
})(["outline:none;position:relative;width:24px;height:24px;border:none;background:none;cursor:pointer;transition:opacity 0.3s ease-in-out;opacity:1;&:hover{opacity:0.5;}&:active{opacity:0.8;}&:after,&:before{content:'';position:absolute;top:50%;left:50%;width:24px;height:2px;background-color:#000;transform:translate(-50%,-50%) rotate(45deg);}&:before{transform:translate(-50%,-50%) rotate(-45deg);}"]);
var CanvasContainer = exports.CanvasContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__CanvasContainer",
  componentId: "sc-48gcj7-10"
})(["display:flex;justify-content:center;position:relative;"]);
var Pad = exports.Pad = _styledComponents["default"].canvas.withConfig({
  displayName: "styles__Pad",
  componentId: "sc-48gcj7-11"
})(["background-color:#f5f5f5;width:", "px;height:", "px;cursor:crosshair;"], function (p) {
  return p.width;
}, function (p) {
  return p.height;
});
var ClearButton = exports.ClearButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__ClearButton",
  componentId: "sc-48gcj7-12"
})(["padding:4px 12px;border:none;outline:none;color:", ";background-color:", ";text-transform:uppercase;border-radius:3px;font-size:14px;cursor:pointer;position:absolute;top:12px;left:12px;"], _palette.commonPalette.txLightGrey, _palette.commonPalette.disabledText);
var ColorsContainer = exports.ColorsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ColorsContainer",
  componentId: "sc-48gcj7-13"
})(["position:absolute;top:12px;right:12px;display:flex;justify-content:center;gap:8px;"]);

// Add check if selected
var ColorButton = exports.ColorButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__ColorButton",
  componentId: "sc-48gcj7-14"
})(["width:12px;height:12px;border:none;border-radius:50%;cursor:pointer;background-color:", ";outline:none;transition:all 0.3s ease-in-out;&:hover{transform:scale(1.12);}", ""], function (p) {
  return p.color;
}, function (p) {
  return p.selected && "\n    transform: scale(1.12);\n    &:after {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        color:white;\n        content: '\u2713';\n        font-size: 8px;\n    }\n  ";
});
var COLORS = exports.COLORS = {
  blue: _palette.commonPalette.blue,
  black: _palette.commonPalette.txBlack,
  red: _palette.commonPalette.red
};
//# sourceMappingURL=styles.js.map